(() => {
const init = async () => {
await customElements.whenDefined('product-variants');
document.querySelectorAll('product-page[data-id="9171574849713"]').forEach(page => {
if (page.dataset.pieReady) return;
const picker = page.querySelector('product-variants');
const form = page.querySelector('form[action*="/cart/add"]');
if (!picker || !form) return;
const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
const names = ['Pumpkin','Apple Crumble','Pecan','Chocolate Pecan','Chocolate Cream','Coconut Cream','Peanut Butter Cream','Cookies & Cream','Key Lime'];
const selected = new Set();
const box = document.createElement('fieldset');
box.className = 'sft-pie-choices';
const legend = document.createElement('legend'); legend.textContent = 'Choose 3 different pies'; box.append(legend);
const note = document.createElement('p'); note.textContent = 'Three 9-inch pies for $90. Gluten-free pies excluded.'; box.append(note);
const status = document.createElement('p'); status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); box.append(status);
const list = document.createElement('div'); list.className = 'sft-pie-list'; box.append(list);
names.forEach(name => {
const label = document.createElement('label');
const input = document.createElement('input'); input.type = 'checkbox'; input.value = name;
input.addEventListener('change', () => { if(input.checked) selected.add(name); else selected.delete(name); update(); });
const text = document.createElement('span'); text.textContent = name;
label.append(input,text); list.append(label);
});
const button = form.querySelector('[data-js-product-add-to-cart]');
const buttonText = form.querySelector('[data-js-product-add-to-cart-text]');
let match = null;
function update() {
const title = names.filter(n => selected.has(n)).join(' + ');
match = selected.size === 3 ? variants.find(v => v.title === title) : null;
list.querySelectorAll('input').forEach(i => { i.disabled = selected.size >= 3 && !i.checked; });
if(match) {
const radio = [...picker.querySelectorAll('input[type="radio"]')].find(i => i.value === match.title);
const select = picker.querySelector('select');
if(radio){radio.checked = true; radio.dispatchEvent(new Event('change',{bubbles:true}));}
else if(select){select.value = match.title; select.dispatchEvent(new Event('change',{bubbles:true}));}
}
const ready = !!(match && match.available);
if(button){button.disabled = !ready; button.classList.toggle('disabled',!ready);}
if(buttonText) buttonText.textContent = ready ? 'Add to cart — $90' : selected.size === 3 ? 'Combination sold out' : 'Choose 3 pies';
status.textContent = selected.size + ' of 3 selected' + (selected.size === 3 ? ready ? ' — ready to add to cart' : ' — this combination is sold out; please change a flavor' : '');
}
page.addEventListener('submit', e => {
if(e.target === form && (!match || !match.available || selected.size !== 3)){
e.preventDefault(); e.stopImmediatePropagation(); status.focus();
}
},true);
page.querySelectorAll('.shopify-payment-button').forEach(e=> e.style.display='none');
picker.before(box); picker.style.display='none'; page.dataset.pieReady='true';
const variantId = new URLSearchParams(location.search).get('variant');
const initial = variants.find(v => String(v.id) === variantId);
if(initial){initial.title.split(' + ').forEach(n=>selected.add(n));list.querySelectorAll('input').forEach(i=>i.checked=selected.has(i.value));}
update();
});
};
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
document.addEventListener('shopify:section:load',init);
})();